import VehicleIcon from '@/api/master/VehicleIcon'
import Functions from '@/functions'

export default {
  namespaced: true,
  state: {
    total: 0,
    data: [],
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data.data
      state.total = data.total
    },
  },
  actions: {
    datatable({commit}, params) {
      return VehicleIcon.datatable(params).then(res => {
        commit('SET_DATA', res.data.message)
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    detail({}, id) {
      return VehicleIcon.detail(id).then(res => {
        const {data} = res.data.message
        return data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    store({}, data) {
      const form = new FormData()
      Object.keys(data).map(index => {
        if(data[index]) form.append(index, data[index])
      })

      return VehicleIcon.store(form).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    update({}, {id, ...data}) {
      const form = new FormData()
      Object.keys(data).map(index => {
        if(data[index]) form.append(index, data[index])
      })

      return VehicleIcon.update(id, form).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    delete({}, id) {
      return VehicleIcon.delete(id).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    }
  },
  getters: {}
}
